// TODO: consider replacing this enum with EDSEntityCodes enum
export enum DocumentEntityType {
  ClaimSet = 'claimSet',
  Claim = 'claimEntity',
  Claimant = 'claimant',
}
